module.exports = __webpack_public_path__ + "static/jeremiahs-34b48d99675731a5255536ad71bf3050.jpg";